export function EventCountdownFrame() {
  return (
    <svg
      width="97"
      height="97"
      viewBox="0 0 97 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g data-figma-bg-blur-radius="75">
        <rect
          x="0.75"
          y="0.75"
          width="95.5"
          height="95.5"
          rx="23.25"
          fill="white"
          fill-opacity="0.2"
        />
        <rect
          x="0.75"
          y="0.75"
          width="95.5"
          height="95.5"
          rx="23.25"
          stroke="url(#paint0_linear_21444_95920)"
          stroke-width="1.5"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_21444_95920"
          x1="51.937"
          y1="-1.82024e-06"
          x2="79.3093"
          y2="88.5376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.3" />
          <stop offset="1" stop-color="white" stop-opacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
